import { render, staticRenderFns } from "./CheckMicro.vue?vue&type=template&id=3505c9f6&"
import script from "./CheckMicro.vue?vue&type=script&lang=js&"
export * from "./CheckMicro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports